{
  "dateFormats": {
    "long": "d 'de' MMMM 'de' yyyy",
    "short": "dd/MM/yyyy"
  },
  "card": {
    "badge": "Certificado",
    "code": "Código:",
    "issuedAt": "Emitido el:",
    "completedAt": "Completado el:",
    "completed": "Completado",
    "view": "Ver",
    "downloading": "Descargando...",
    "download": "Descargar"
  },
  "viewer": {
    "title": "Certificado de finalización",
    "description": "Vista del certificado",
    "student": "Estudiante",
    "code": "Código",
    "issueDate": "Fecha de emisión",
    "status": "Estado",
    "valid": "Válido",
    "loading": "Cargando certificado...",
    "previewTitle": "Vista del certificado",
    "validNotice": "Certificado válido y verificable mediante el código de arriba",
    "openNewTab": "Abrir en una pestaña nueva",
    "downloading": "Descargando...",
    "downloadPdf": "Descargar PDF"
  },
  "generator": {
    "title": "CERTIFICADO DE FINALIZACIÓN",
    "subtitle": "Xtreed - Plataforma de formación",
    "certifyThat": "Certificamos que",
    "completedCourse": "ha completado con éxito el curso",
    "dedication": "demostrando conocimiento y dedicación en sus estudios",
    "completionDate": "Fecha de finalización",
    "verificationCode": "Código de verificación",
    "generatingCode": "Generando...",
    "platform": "Plataforma",
    "validNotice": "Este certificado es válido y puede verificarse mediante el código de arriba.",
    "copyright": "© {{year}} Xtreed. Todos los derechos reservados.",
    "generating": "Generando certificado...",
    "generate": "Generar certificado",
    "generated": "Certificado generado",
    "downloading": "Descargando...",
    "downloadPdf": "Descargar PDF"
  },
  "service": {
    "qrCodeError": "No se pudo generar el código QR",
    "linkedInCopy": {
      "module": {
        "title": "🎓 Módulo completado: {{title}}",
        "description": "¡Acabo de completar el módulo \"{{title}}\" en Xtreed! Un paso más en mi camino de desarrollo profesional. 💻✨",
        "hashtags": "#Xtreed #Programación #Desarrollo #Aprendizaje #TechEducation"
      },
      "course": {
        "title": "🏆 Curso completado: {{title}}",
        "description": "¡Certificado conseguido! Completé con éxito el curso \"{{title}}\" en Xtreed. ¡Conocimiento adquirido y listo para nuevos retos! 🚀",
        "hashtags": "#Xtreed #CertificadoProfesional #Programación #TechSkills #CarreraTech"
      },
      "track": {
        "title": "🎯 Ruta completada: {{title}}",
        "description": "¡Misión cumplida! Terminé toda la ruta \"{{title}}\" en Xtreed. ¡Un recorrido completo de aprendizaje y crecimiento profesional! 🌟",
        "hashtags": "#Xtreed #RutaCompleta #FullStack #DesarrolladorProfesional #TechCareer"
      }
    }
  },
  "blockchainVerifier": {
    "toasts": {
      "enterHash": "Ingresa el hash de la transacción",
      "verifiedTitle": "¡Certificado verificado en la blockchain!",
      "verifiedDescription": "Documento auténtico e inmutable",
      "notFoundTitle": "Hash no encontrado en la blockchain",
      "notFoundDescription": "Verifica que el hash sea correcto",
      "verifiedDemo": "¡Certificado verificado en la blockchain! (DEMO)",
      "hashCopied": "¡Hash copiado!"
    },
    "networkStats": {
      "status": {
        "online": "en línea",
        "delayed": "con retraso",
        "offline": "sin conexión"
      },
      "certificates": "Certificados",
      "transactions": "Transacciones",
      "lastBlock": "Último bloque",
      "averageGas": "Gas medio"
    },
    "header": {
      "title": "Verificación en blockchain",
      "description": "Verifica la autenticidad de los certificados de Xtreed en la blockchain. Los registros inmutables garantizan la máxima seguridad y fiabilidad."
    },
    "form": {
      "title": "Verificar hash de la transacción",
      "description": "Ingresa el hash de la transacción blockchain para verificar un certificado",
      "hashLabel": "Hash de la transacción",
      "supported": "Compatible con: Ethereum y Polygon • Verificación en tiempo real"
    },
    "result": {
      "validTitle": "Certificado verificado en la blockchain ✓",
      "invalidTitle": "Hash no encontrado ✗",
      "validDescription": "Registro encontrado en la blockchain: documento auténtico e inmutable",
      "invalidDescription": "No se pudo encontrar este hash en la blockchain",
      "verifiedAt": "Verificado el {{date}}",
      "block": "Bloque #{{block}}",
      "confirmations_one": "{{count}} confirmación",
      "confirmations_zero": "{{count}} confirmaciones",
      "confirmations_other": "{{count}} confirmaciones",
      "explorer": "Explorador",
      "copy": "Copiar"
    },
    "details": {
      "title": "Datos del certificado verificado",
      "certificateInfo": "Información del certificado",
      "certificateId": "ID del certificado",
      "student": "Estudiante",
      "course": "Curso/Contenido",
      "issueDate": "Fecha de emisión",
      "blockchainData": "Datos de la blockchain",
      "transactionHash": "Hash de la transacción",
      "certificateHash": "Hash del certificado",
      "block": "Bloque",
      "timestamp": "Marca de tiempo"
    },
    "advanced": {
      "show": "Mostrar información técnica",
      "hide": "Ocultar información técnica",
      "network": "Red",
      "gasUsed": "Gas usado",
      "confirmations": "Confirmaciones",
      "about": "<bold>Sobre la verificación en blockchain:</bold> Este certificado se ha registrado de forma inmutable en la blockchain {{network}}. El hash único garantiza que el documento no puede falsificarse ni alterarse tras su emisión."
    },
    "newVerification": "Nueva verificación",
    "howItWorks": {
      "title": "Cómo funciona la verificación en blockchain",
      "item1": "Cada certificado de Xtreed se registra en la blockchain con un hash único",
      "item2": "El registro es inmutable y permanente: no puede alterarse ni falsificarse",
      "item3": "La verificación es instantánea y funciona 24/7 en cualquier parte del mundo",
      "item4": "Admitimos tanto Ethereum como Polygon para una máxima compatibilidad"
    },
    "formats": {
      "dateTime": "dd/MM/yyyy HH:mm",
      "shortDateTime": "dd/MM HH:mm",
      "longDate": "d 'de' MMMM 'de' yyyy"
    }
  },
  "gallery": {
    "toasts": {
      "loadError": "Error al cargar los certificados",
      "downloadStarted": "¡Descarga iniciada!",
      "downloadError": "Error al descargar el certificado",
      "sharedOnLinkedIn": "¡Compartido en LinkedIn!",
      "linkCopied": "¡Enlace copiado al portapapeles!",
      "shareError": "Error al compartir el certificado"
    },
    "fileName": "certificado-{{id}}.pdf",
    "stats": {
      "total": "Total de certificados",
      "modules": "Módulos completados",
      "courses": "Cursos completados",
      "tracks": "Rutas completadas"
    },
    "types": {
      "module": "Módulo",
      "course": "Curso",
      "track": "Ruta"
    },
    "badges": {
      "physical": "Físico"
    },
    "menu": {
      "view": "Ver",
      "download": "Descargar",
      "share": "Compartir"
    },
    "issuedOn": "Emitido el {{date}}",
    "metrics": {
      "views": "Vistas",
      "downloads": "Descargas",
      "shares": "Compartidos"
    },
    "actions": {
      "view": "Ver",
      "download": "Descargar"
    },
    "title": "Mis certificados",
    "found_one": "{{count}} certificado encontrado",
    "found_zero": "{{count}} certificados encontrados",
    "found_other": "{{count}} certificados encontrados",
    "searchPlaceholder": "Buscar certificados...",
    "filters": {
      "all": "Todos",
      "module": "Módulos",
      "course": "Cursos",
      "track": "Rutas"
    },
    "sort": {
      "newest": "Más reciente",
      "oldest": "Más antiguo",
      "name": "Nombre",
      "type": "Tipo"
    },
    "selected_one": "{{count}} certificado seleccionado",
    "selected_zero": "{{count}} certificados seleccionados",
    "selected_other": "{{count}} certificados seleccionados",
    "batch": {
      "download": "Descarga en lote",
      "share": "Compartir"
    },
    "loading": "Cargando certificados...",
    "empty": {
      "noResultsTitle": "No se encontró ningún certificado",
      "noCertificatesTitle": "Todavía no tienes certificados",
      "noResultsDescription": "Intenta ajustar los filtros de búsqueda",
      "noCertificatesDescription": "Completa cursos y módulos para recibir tus certificados profesionales",
      "exploreCourses": "Explorar cursos"
    },
    "formats": {
      "date": "dd/MM/yyyy"
    }
  },
  "generatorV3": {
    "typeTitles": {
      "module": "CERTIFICADO DE MÓDULO",
      "course": "CERTIFICADO DE FINALIZACIÓN",
      "track": "CERTIFICADO DE RUTA",
      "default": "CERTIFICADO PROFESIONAL"
    },
    "toasts": {
      "generatedTitle": "¡Certificado generado con éxito!",
      "generatedSharedOnLinkedIn": "¡También se ha compartido en tu LinkedIn!",
      "generatedReady": "Certificado listo para descargar.",
      "viewAction": "Ver",
      "internalServerError": "Error interno del servidor",
      "generateError": "Error al generar el certificado",
      "downloadStarted": "¡Descarga iniciada!",
      "downloadError": "Error al descargar el certificado",
      "alreadyShared": "¡El certificado ya se ha compartido automáticamente!"
    },
    "fileName": "certificado-{{id}}.pdf",
    "completedOn": "Completado el {{date}}",
    "tagline": "Xtreed - Plataforma de Desarrollo Profesional",
    "body": {
      "certifyThat": "Certificamos que",
      "completedModule": "ha completado con éxito el módulo",
      "completedTrack": "ha completado toda la ruta",
      "completedCourse": "ha completado con éxito el curso",
      "demonstrating": "demostrando conocimiento y dedicación en sus estudios"
    },
    "options": {
      "title": "Opciones avanzadas",
      "qrCode": "Código QR de verificación",
      "blockchain": "Registro en blockchain",
      "linkedin": "Compartir en LinkedIn",
      "physicalDelivery": "Entrega física"
    },
    "details": {
      "completionDate": "Fecha de finalización",
      "verificationCode": "Código de verificación",
      "willBeGenerated": "Se generará...",
      "onlineVerification": "Verificación online",
      "available247": "Disponible 24/7"
    },
    "footer": {
      "validity": "Este certificado es válido y puede verificarse mediante su código QR y su código únicos.",
      "blockchain": "El registro en blockchain garantiza la autenticidad e integridad del documento.",
      "copyright": "© {{year}} Xtreed. Todos los derechos reservados."
    },
    "actions": {
      "generating": "Generando certificado...",
      "generate": "Generar certificado profesional",
      "success": "¡Certificado generado con éxito!",
      "downloadPdf": "Descargar PDF",
      "verify": "Verificar"
    },
    "formats": {
      "date": "dd/MM/yyyy",
      "longDate": "d 'de' MMMM 'de' yyyy"
    }
  },
  "verificationV3": {
    "toasts": {
      "enterCode": "Ingresa el código de verificación",
      "successTitle": "¡Certificado verificado con éxito!",
      "successDescription": "Documento auténtico y válido",
      "invalidTitle": "Certificado no válido",
      "error": "Error en la verificación",
      "linkCopied": "¡Enlace copiado!"
    },
    "unableToVerify": "No se pudo verificar la autenticidad",
    "header": {
      "title": "Verificación de certificado",
      "description": "Ingresa el código de verificación del certificado para validar su autenticidad. Todos los certificados de Xtreed están protegidos con blockchain y firma digital."
    },
    "form": {
      "title": "Verificar certificado",
      "codeLabel": "Código de verificación",
      "placeholder": "Ej.: DCF-2024-ABCD-1234",
      "availability": "Verificación disponible 24/7 • Tecnología blockchain"
    },
    "result": {
      "validTitle": "Certificado válido ✓",
      "invalidTitle": "Certificado no válido ✗",
      "validDescription": "Documento auténtico y verificado",
      "verifiedAt": "Verificado el {{date}}",
      "details": "Detalles"
    },
    "info": {
      "title": "Información del certificado",
      "student": "Estudiante",
      "course": "Curso/Contenido",
      "issueDate": "Fecha de emisión",
      "type": "Tipo de certificado",
      "types": {
        "module": "Módulo",
        "course": "Curso",
        "track": "Ruta"
      },
      "status": "Estado: <active>Activo</active>",
      "share": "Compartir"
    },
    "advanced": {
      "title": "Verificaciones de seguridad avanzadas",
      "checks": {
        "qrCode": "Código QR válido",
        "digitalSignature": "Firma digital",
        "blockchain": "Blockchain verificada",
        "template": "Plantilla válida",
        "notRevoked": "No revocado",
        "withinValidity": "Dentro del periodo de validez"
      },
      "maxSecurityTitle": "Máxima seguridad:",
      "maxSecurityDescription": "Este certificado utiliza múltiples capas de seguridad, incluidas blockchain, firma digital criptográfica y verificación en tiempo real."
    },
    "warnings": "Avisos",
    "verifyAnother": "Verificar otro certificado",
    "formats": {
      "dateTime": "dd/MM/yyyy HH:mm",
      "longDate": "d 'de' MMMM 'de' yyyy"
    }
  },
  "viewerV3": {
    "fileName": "certificado-{{id}}",
    "dialogDescription": "Visualización del certificado",
    "formats": {
      "date": "dd/MM/yyyy",
      "dateTime": "dd/MM/yyyy HH:mm"
    },
    "toasts": {
      "downloadStarted": "¡Descarga iniciada!",
      "downloadStartedDescription": "Certificado en PDF de alta calidad",
      "downloadError": "Error al descargar el certificado",
      "linkedInShared": "¡Compartido en LinkedIn!",
      "linkedInSharedDescription": "Certificado añadido a tu perfil",
      "viewPost": "Ver publicación",
      "linkedInShareError": "Error al compartir en LinkedIn",
      "screenshotSaved": "¡Captura guardada!",
      "screenshotError": "Error al hacer la captura",
      "linkCopied": "¡Enlace copiado!",
      "linkCopiedDescription": "Enlace de verificación copiado al portapapeles",
      "comingSoon": "¡Próximamente!",
      "physicalDeliveryComingSoon": "La función de entrega física estará disponible próximamente"
    },
    "info": {
      "student": "Estudiante",
      "code": "Código",
      "issueDate": "Fecha de emisión",
      "status": "Estado"
    },
    "status": {
      "valid": "Válido",
      "revoked": "Revocado",
      "pending": "Pendiente"
    },
    "metrics": {
      "views": "Visualizaciones",
      "downloads": "Descargas",
      "verifications": "Verificaciones",
      "shares": "Veces compartido"
    },
    "title": {
      "module": "Certificado de módulo",
      "track": "Certificado de ruta",
      "course": "Certificado de finalización"
    },
    "tabs": {
      "preview": "Vista previa",
      "details": "Detalles",
      "sharing": "Compartir",
      "verification": "Verificación"
    },
    "preview": {
      "loading": "Cargando certificado...",
      "iframeTitle": "Vista previa del certificado"
    },
    "details": {
      "contentInfo": "Información del contenido",
      "title": "Título",
      "description": "Descripción",
      "workload": "Carga horaria",
      "hours": "{{hours}} h",
      "skills": "Competencias certificadas",
      "security": "Seguridad y verificación",
      "validSignature": "Firma digital válida",
      "signedBy": "Firmado por {{issuer}} el {{date}}",
      "blockchainRegistered": "Registrado en la blockchain",
      "hash": "Hash: {{hash}}...",
      "viewOnBlockchain": "Ver en la blockchain →"
    },
    "qrCode": {
      "title": "Código QR de verificación",
      "scanToVerify": "Escanéalo para verificar la autenticidad"
    },
    "physicalDelivery": {
      "requested": "Entrega física solicitada",
      "status": "Estado:",
      "delivered": "Entregado",
      "shipped": "Enviado",
      "processing": "En proceso",
      "trackingCode": "Código de seguimiento:",
      "requestProcessing": "Solicitud en proceso..."
    },
    "sharing": {
      "social": "Compartir en redes sociales",
      "shareOnLinkedIn": "Compartir en LinkedIn",
      "copyVerificationLink": "Copiar enlace de verificación",
      "saveAsImage": "Guardar como imagen",
      "sharedOnLinkedIn": "Compartido en LinkedIn",
      "sharedAt": "El {{date}}",
      "copyLink": "Copiar enlace"
    },
    "verification": {
      "title": "Verificación de autenticidad",
      "publicLink": "Enlace público de verificación",
      "copy": "Copiar",
      "open": "Abrir",
      "code": "Código de verificación",
      "codeHint": "Usa este código en el formulario de verificación",
      "howTo": "<bold>Cómo verificar:</bold> cualquier persona puede verificar la autenticidad de este certificado usando el código o el enlace de arriba. La verificación incluye blockchain, firma digital y validaciones de integridad."
    },
    "footer": {
      "validId": "Certificado válido y verificable • ID: {{id}}...",
      "openInNewTab": "Abrir en una pestaña nueva",
      "downloadPdf": "Descargar PDF",
      "requestPhysical": "Solicitar copia física"
    }
  },
  "linkedIn": {
    "defaults": {
      "headline": "Alumno de Xtreed",
      "module": {
        "title": "🎓 Módulo completado: {title}",
        "description": "¡Acabo de completar el módulo \"{title}\" en Xtreed! Un paso más en mi camino de desarrollo profesional. 💻✨",
        "hashtags": "#Xtreed, #Aprendizaje, #Conocimiento, #Certificado"
      },
      "course": {
        "title": "🏆 Curso completado: {title}",
        "description": "¡Certificado conseguido! Completé con éxito el curso \"{title}\" en Xtreed. ¡Conocimiento adquirido y listo para nuevos retos! 🚀",
        "hashtags": "#Xtreed, #CertificadoProfesional, #Aprendizaje, #Carrera"
      },
      "track": {
        "title": "🎯 Ruta completada: {title}",
        "description": "¡Misión cumplida! Terminé toda la ruta \"{title}\" en Xtreed. ¡Un recorrido completo de aprendizaje y crecimiento profesional! 🌟",
        "hashtags": "#Xtreed, #RutaCompletada, #Formación, #Carrera"
      }
    },
    "toasts": {
      "comingSoon": "¡Próximamente!",
      "comingSoonDescription": "La integración con LinkedIn estará disponible próximamente",
      "connected": "¡Conectado a LinkedIn!",
      "connectError": "Error al conectar con LinkedIn",
      "disconnected": "Desconectado de LinkedIn",
      "disconnectError": "Error al desconectar",
      "saved": "¡Configuración guardada!",
      "saveError": "Error al guardar la configuración"
    },
    "templateEditor": {
      "postTitle": "Título de la publicación",
      "postTitlePlaceholder": "Ej.: 🎓 Módulo completado: {title}",
      "titleHint": "Usa {title} para insertar el nombre del certificado automáticamente",
      "description": "Descripción",
      "descriptionPlaceholder": "Describe tu logro...",
      "hashtags": "Hashtags",
      "hashtagsPlaceholder": "#Xtreed, #Aprendizaje, #Certificado",
      "hashtagsHint": "Separa los hashtags con comas"
    },
    "post": {
      "now": "Ahora",
      "professionalCertificate": "CERTIFICADO PROFESIONAL",
      "like": "👍 Recomendar",
      "comment": "💬 Comentar",
      "repost": "🔄 Compartir",
      "send": "📤 Enviar"
    },
    "header": {
      "title": "Integración con LinkedIn",
      "subtitle": "Configura la publicación automática de tus certificados en LinkedIn. ¡Aporta credibilidad a tu perfil profesional y celebra tus logros!"
    },
    "connection": {
      "connectedTitle": "LinkedIn conectado",
      "connectTitle": "Conectar con LinkedIn",
      "connectedAs": "Conectado como {{name}}",
      "connectDescription": "Conecta tu cuenta para compartir certificados automáticamente",
      "viewProfile": "Ver perfil",
      "disconnect": "Desconectar",
      "connect": "Conectar LinkedIn"
    },
    "profile": {
      "name": "Nombre:",
      "headline": "Titular:",
      "publicProfile": "Perfil público:"
    },
    "tabs": {
      "settings": "Configuración",
      "templates": "Plantillas",
      "preview": "Vista previa"
    },
    "settings": {
      "title": "Configuración de publicación",
      "enable": "Activar integración",
      "enableDescription": "Permite que Xtreed publique en tu LinkedIn",
      "autoShare": "Publicación automática",
      "autoShareDescription": "Publica automáticamente cuando recibes un certificado",
      "postSettings": "Configuración de la publicación",
      "includeImage": "Incluir imagen del certificado",
      "includeImageDescription": "Adjunta una vista previa visual",
      "includeDescription": "Incluir descripción detallada",
      "includeDescriptionDescription": "Añade texto descriptivo",
      "addToEducation": "Añadir a la sección Educación",
      "addToEducationDescription": "Aparece en la cronología",
      "addToCertifications": "Añadir a Certificaciones",
      "addToCertificationsDescription": "Sección de licencias y certificaciones",
      "visibility": "Visibilidad de las publicaciones",
      "public": "Público",
      "connections": "Contactos",
      "private": "Privado"
    },
    "templates": {
      "modules": "Módulos",
      "tracks": "Rutas",
      "courses": "Cursos",
      "hidePreview": "Ocultar vista previa",
      "showPreview": "Ver vista previa"
    },
    "preview": {
      "sampleTitle": "React.js completo: de básico a avanzado",
      "title": "Vista previa de las publicaciones",
      "description": "Mira cómo aparecerán tus certificados en LinkedIn",
      "testTitle": "Título del certificado (para pruebas)",
      "testTitlePlaceholder": "Nombre del curso o módulo",
      "module": "Módulo",
      "course": "Curso",
      "track": "Ruta"
    },
    "permissions": {
      "title": "Sobre los permisos",
      "description": "Xtreed utiliza la API oficial de LinkedIn con permisos limitados y seguros. Nunca publicaremos sin tu autorización previa y puedes desconectarte en cualquier momento."
    },
    "unsaved": {
      "title": "Cambios sin guardar",
      "description": "Tu configuración ha cambiado",
      "save": "Guardar"
    }
  },
  "physicalDelivery": {
    "formats": {
      "date": "dd/MM/yyyy",
      "dateTime": "dd/MM/yyyy HH:mm"
    },
    "zipCodeLine": "CP: {{zipCode}}",
    "shipping": {
      "standard": {
        "name": "Estándar",
        "description": "Entrega económica por Correios"
      },
      "express": {
        "name": "Exprés",
        "description": "Entrega rápida con SEDEX"
      },
      "premium": {
        "name": "Premium",
        "description": "Entrega especial con embalaje de lujo"
      },
      "features": {
        "premiumPaper": "Certificado en papel premium",
        "protectiveEnvelope": "Sobre protector",
        "basicTracking": "Seguimiento básico",
        "fullTracking": "Seguimiento completo",
        "insuranceIncluded": "Seguro incluido",
        "specialPaper": "Certificado en papel especial de 300 g",
        "premiumBox": "Caja premium Xtreed",
        "customEnvelope": "Sobre personalizado",
        "authenticitySeal": "Sello de autenticidad",
        "realTimeTracking": "Seguimiento en tiempo real",
        "fullInsurance": "Seguro a todo riesgo",
        "signatureDelivery": "Entrega con firma"
      },
      "businessDays_one": "{{count}} día hábil",
      "businessDays_zero": "{{count}} días hábiles",
      "businessDays_other": "{{count}} días hábiles",
      "title": "Elige el método de envío",
      "summary": "Resumen del envío",
      "method": "Método:",
      "cost": "Importe:",
      "deadline": "Plazo:"
    },
    "toasts": {
      "loadError": "Error al cargar la información de entrega",
      "requiredFields": "Completa todos los campos obligatorios",
      "requested": "¡Entrega física solicitada!",
      "estimatedDelivery": "Entrega estimada: {{date}}",
      "requestError": "Error al solicitar la entrega física",
      "codeCopied": "¡Código copiado!"
    },
    "progress": {
      "pending": "Solicitado",
      "processing": "Procesando",
      "shipped": "Enviado",
      "delivered": "Entregado"
    },
    "tracking": {
      "title": "Seguimiento de la entrega - {{title}}",
      "loading": "Cargando información...",
      "orderInfo": "Información del pedido",
      "certificate": "Certificado:",
      "status": "Estado:",
      "delivered": "Entregado",
      "shipped": "Enviado",
      "processing": "En proceso",
      "requestedAt": "Solicitado el:",
      "deliveryAddress": "Dirección de entrega",
      "trackingCode": "Código de seguimiento",
      "copy": "Copiar",
      "track": "Seguir envío",
      "latestUpdates": "Últimas actualizaciones",
      "refresh": "Actualizar estado"
    },
    "header": {
      "title": "Entrega física del certificado",
      "subtitle": "Recibe tu certificado impreso en casa con calidad profesional. Papel premium, embalaje especial y entrega con seguimiento a todo Brasil."
    },
    "form": {
      "title": "Datos de entrega",
      "personalInfo": "Información personal",
      "fullName": "Nombre completo *",
      "fullNamePlaceholder": "Nombre tal como debe aparecer en la entrega",
      "phone": "Teléfono *",
      "email": "Correo electrónico *",
      "emailPlaceholder": "tu@email.com",
      "address": "Dirección de entrega",
      "zipCode": "Código postal *",
      "street": "Calle/Avenida *",
      "streetPlaceholder": "Nombre de la calle",
      "number": "Número *",
      "complement": "Complemento",
      "complementPlaceholder": "Depto. 4B",
      "neighborhood": "Barrio *",
      "neighborhoodPlaceholder": "Nombre del barrio",
      "city": "Ciudad *",
      "cityPlaceholder": "Tu ciudad",
      "state": "Estado *",
      "statePlaceholder": "Estado",
      "country": "País",
      "countryValue": "Brasil",
      "specialInstructions": "Instrucciones especiales",
      "specialInstructionsPlaceholder": "Observaciones para el repartidor (opcional)"
    },
    "actions": {
      "continue": "Continuar",
      "back": "Volver"
    },
    "confirmation": {
      "title": "Confirmación del pedido",
      "certificateToSend": "Certificado que se enviará",
      "titleLabel": "Título:",
      "idLabel": "ID:",
      "issuedAt": "Emitido el:",
      "deliveryData": "Datos de entrega",
      "name": "Nombre:",
      "phone": "Teléfono:",
      "email": "Correo electrónico:",
      "address": "Dirección:",
      "financialSummary": "Resumen económico",
      "certificate": "Certificado:",
      "free": "Gratis",
      "shipping": "Envío ({{method}}):",
      "total": "Total:",
      "paymentInfo": "<bold>Sobre el pago:</bold> el importe del envío se cobrará solo en el momento del envío. Recibirás un enlace de pago cuando el certificado esté listo para enviarse.",
      "confirm": "Confirmar pedido"
    }
  },
  "templateEditor": {
    "title": {
      "create": "Crear plantilla",
      "edit": "Editar plantilla",
      "view": "Ver plantilla"
    },
    "dialogDescription": "Configura la plantilla de certificado",
    "unsaved": "Sin guardar",
    "actions": {
      "edit": "Editar",
      "preview": "Vista previa",
      "save": "Guardar"
    },
    "toasts": {
      "nameRequired": "El nombre y el nombre visible son obligatorios",
      "created": "¡Plantilla creada!",
      "updated": "¡Plantilla actualizada!",
      "saveError": "Error al guardar la plantilla"
    },
    "tabs": {
      "general": "General",
      "design": "Diseño",
      "elements": "Elementos",
      "advanced": "Avanzado"
    },
    "general": {
      "title": "Información básica",
      "nameLabel": "Nombre de la plantilla *",
      "namePlaceholder": "Nombre interno",
      "displayNameLabel": "Nombre visible *",
      "displayNamePlaceholder": "Nombre visible para los usuarios",
      "descriptionLabel": "Descripción",
      "descriptionPlaceholder": "Descripción de la plantilla",
      "typeLabel": "Tipo de certificado",
      "types": {
        "module": "Módulo",
        "course": "Curso",
        "track": "Ruta"
      },
      "designVariantLabel": "Variante de diseño"
    },
    "designVariants": {
      "minimal": {
        "label": "Minimalista",
        "description": "Diseño limpio y moderno"
      },
      "classic": {
        "label": "Clásico",
        "description": "Estilo tradicional y elegante"
      },
      "modern": {
        "label": "Moderno",
        "description": "Aspecto contemporáneo"
      },
      "premium": {
        "label": "Premium",
        "description": "Diseño lujoso con acabados"
      },
      "elite": {
        "label": "Élite",
        "description": "Máximo nivel de sofisticación"
      }
    },
    "design": {
      "colorsTitle": "Colores de la plantilla",
      "colorKeys": {
        "primary": "principal",
        "secondary": "secundario",
        "accent": "acento",
        "text": "texto",
        "background": "fondo"
      },
      "presetColors": "Colores predefinidos",
      "typographyTitle": "Tipografía",
      "fontKeys": {
        "primary": "principal",
        "secondary": "secundaria",
        "accent": "acento"
      }
    },
    "elements": {
      "title": "Elementos de la plantilla",
      "add": "Añadir",
      "addDialogTitle": "Añadir elemento",
      "addDialogDescription": "Selecciona un tipo de elemento para añadir a la plantilla",
      "emptyTitle": "Aún no se ha añadido ningún elemento",
      "emptyDescription": "Haz clic en \"Añadir\" para empezar"
    },
    "elementTypes": {
      "text": {
        "label": "Texto",
        "description": "Añadir texto dinámico"
      },
      "image": {
        "label": "Imagen",
        "description": "Insertar logo o imagen"
      },
      "background": {
        "label": "Fondo",
        "description": "Color o degradado de fondo"
      },
      "border": {
        "label": "Borde",
        "description": "Marcos decorativos"
      },
      "qrCode": {
        "label": "Código QR",
        "description": "Código de verificación"
      },
      "signature": {
        "label": "Firma",
        "description": "Firma digital"
      }
    },
    "element": {
      "name": "Nombre",
      "zIndex": "Z-Index",
      "x": "X (mm)",
      "y": "Y (mm)",
      "width": "Ancho",
      "height": "Alto",
      "content": "Contenido",
      "variable": "Variable",
      "fontSize": "Tamaño de fuente",
      "color": "Color",
      "imageUrl": "URL de la imagen"
    },
    "advanced": {
      "printSpecsTitle": "Especificaciones de impresión",
      "dpi": "DPI",
      "colorMode": "Modo de color"
    },
    "preview": {
      "title": "Vista previa",
      "simplified": "Vista previa simplificada",
      "dimensions": "Dimensiones: {{width}}x{{height}}mm",
      "elementsCount_one": "Elementos: {{count}}",
      "elementsCount_zero": "Elementos: {{count}}",
      "elementsCount_other": "Elementos: {{count}}"
    }
  }
}
